import { VariablesOf } from '@graphql-typed-document-node/core';
import { useQuery } from '@tanstack/react-query';

import { StaleTime } from 'queries/types';
import { PageEventsDocument } from 'types/api/dato-operations.types';

import { pageEventsQuery } from './queries';

export const usePageEvents = (
  variables: VariablesOf<typeof PageEventsDocument>,
  config?: Partial<ReturnType<typeof pageEventsQuery>>,
) => {
  const { data, isPending } = useQuery({
    ...pageEventsQuery(variables),
    staleTime: StaleTime.FOREVER,
    ...config,
  });

  return {
    events: data?.allPageEvents,
    isPending,
  };
};
